const FdapnStatusNotificationApiUrls = {
  GET: `${process.env.REACT_APP_USER_FDA_PN_URL}/fda-pn/status-notification/get`,
  POST: `${process.env.REACT_APP_USER_FDA_PN_URL}/fda-pn/status-notification/create`,
  PUT: `${process.env.REACT_APP_USER_FDA_PN_URL}/fda-pn/status-notification/update`,
  DELETE: `${process.env.REACT_APP_USER_FDA_PN_URL}/fda-pn/status-notification/delete`,
  EXPORT: `${process.env.REACT_APP_USER_FDA_PN_URL}/fda-pn/status-notification/download`
}
 
export default FdapnStatusNotificationApiUrls
